import { cn } from "@/lib/utils";
import { forwardRef } from "react";
import {
  Terminology,
  Term,
  TerminologyLabels,
  TerminologyOptions,
} from "@/types/v2";
import { EditTermDialog } from "@/components/Settings/Shop/EditTermDialog";

export interface TermProps {
  termKey: TerminologyOptions;
  term: Term;
  onEdit?: (key: keyof Terminology, term: Term) => Promise<void>;
}

export interface TerminologyListProps {
  terminology: Terminology;
  className?: string;
  onEdit?: (key: keyof Terminology, term: Term) => Promise<void>;
}

const TermItem = forwardRef<HTMLDivElement, TermProps>(
  ({ termKey, term, onEdit }, ref) => {
    return (
      <div
        ref={ref}
        className="flex items-center justify-between rounded-md border border-gray-200 px-4 py-3"
      >
        <div className="flex flex-col">
          <span className="font-medium">{TerminologyLabels[termKey]}</span>
          <div className="mt-1 text-sm text-gray-500">
            <div>Singular: {term.singular}</div>
            <div>Plural: {term.plural}</div>
            <div>Acronym: {term.acronym}</div>
          </div>
        </div>
        <EditTermDialog
          termKey={termKey}
          term={term}
          onSave={(updatedTerm) => {
            if (onEdit) {
              onEdit(termKey, updatedTerm);
            }
          }}
        />
      </div>
    );
  }
);
TermItem.displayName = "TermItem";

const TerminologyList = forwardRef<HTMLDivElement, TerminologyListProps>(
  ({ terminology, className, onEdit }, ref) => (
    <div
      ref={ref}
      className={cn("flex flex-col gap-4 sm:grid sm:grid-cols-2", className)}
    >
      {Object.entries(terminology).map(([key, term]) => (
        <TermItem
          key={key}
          termKey={key as keyof Terminology}
          term={term}
          onEdit={onEdit}
        />
      ))}
    </div>
  )
);
TerminologyList.displayName = "TerminologyList";

export { TerminologyList, TermItem };
